import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`With Vue 3, developers can use `}<inlineCode parentName="p">{`provide()`}</inlineCode>{` and `}<inlineCode parentName="p">{`inject()`}</inlineCode>{` to pipe global values into any component without prop drilling. And if you don't know what prop drilling is, good for you.`}</p>
    <p>{`While this method is more declarative, as you need to inject PostHog into every component, it avoids “polluting” globals (like the plugins can do). Some engineers prefer this approach, while others include PostHog in globals since it doesn't need to be reactive and will be called throughout your application. `}</p>
    <h4 {...{
      "id": "step-1-initialize-vue"
    }}>{`Step 1: Initialize Vue`}</h4>
    <p>{`Prior to mounting the app, you must:`}</p>
    <ol>
      <li parentName="ol">{`Import PostHog`}</li>
      <li parentName="ol">{`Initialize it`}</li>
      <li parentName="ol">{`Provide it to your app.`}</li>
    </ol>
    <p>{`This `}<strong parentName="p">{`must`}</strong>{` be done `}<em parentName="p">{`before`}</em>{` you mount your app. If you provide PostHog `}<em parentName="p">{`after`}</em>{` mounting it, PostHog will not be predictably available. `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//app.js

import posthog from "posthog-js";

const app = createApp(App);
posthog.init("<ph_project_api_key>", {
  api_host: "<ph_client_api_host>",
  defaults: '<ph_posthog_js_defaults>',
});
app.provide("posthog", posthog);
`}</code></pre>
    <h4 {...{
      "id": "step-2-inject-into-any-vue-file"
    }}>{`Step 2: Inject into any Vue file`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`//component.vue
export default {
  data() {
    return {
      greeting: "How are you!",
    };
  },
  inject: ["posthog"], //grab the injection from app-wide provider
  created() {
    console.log("Created", this.posthog); //posthog accessible!
  },
};
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      